const style = `
  position: fixed;
  border-bottom-width: 4px;
  border-bottom-style: solid;
  top: 0%;
`

export default style
